module.exports = __webpack_public_path__ + "img/bv.bbe76638.jpg";